import styled from 'styled-components';
import { color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useMutation } from '@tanstack/react-query';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

import CreateBoardForm from './CreateBoardForm.jsx';
import { createBoard } from '../data';
import Modal from '../../../shared/Modal/Modal.jsx';
import { useNotification } from '../../../shared/Notification/useNotification';

const CreateBoardWrapper = styled.a`
  ${color}
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 11px 20px;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
`;

const CreateBoardButton = () => {
  const { t } = useTranslation(['header', 'shared']);
  const { showError, showSuccess } = useNotification();
  const { mutate } = useMutation(createBoard, {
    onSuccess: ({ data }) => {
      Swal.close();
      showSuccess({
        title: t('header:createBoardButton.successTitle'),
        content: t('header:createBoardButton.successText'),
      });
      window.location.assign(data.path);
    },
    onError: () => {
      showError({ content: t('shared:errorText') });
    },
  });

  const createBoardModal = () => {
    Modal({
      component: <CreateBoardForm mutate={mutate} />,
      width: '500px',
      padding: '24px 13px',
    });
  };

  return (
    <CreateBoardWrapper
      color="primary.100"
      onClick={createBoardModal}
      id="createNewBoard"
    >
      {t('header:createBoardButton.createNewBoard')}
    </CreateBoardWrapper>
  );
};

export default CreateBoardButton;
